import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import parse from "react-html-parser";
// import APIs
import DesignLandingApi from "../../api/visitor/DesignLanding";

//import UIs
import { ErrorNotify } from "../../ui/Toast";

import DesignCard from "../../ui/cards/DesignCard";
//import skeletons
import DesignCardSkeleton from "../../ui/skeletons/DesignCard";

import { setIsLoading, setMetaData } from "../../redux/reducers/page";

const DesignLanding = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [landing, setLanding] = React.useState([]);

  // redux
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.customerAuth);
  const { info } = useSelector((state) => state.visitor);
  // find Basket design
  const findDesignLanding = async () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setIsLoaded(false);
    const result = await DesignLandingApi(auth.token, info.token, id);

    if (result.status !== 200) {
      ErrorNotify("طرح وجود ندارد");
      navigate(`/`);
      return;
    }
    setLanding(result.data);
    dispatch(
      setMetaData({
        title: `میشرت :  ${result.data.Design.title}`,
        description: `میشرت: ${result.data.Design.title}`,
      })
    );
    dispatch(setIsLoading(false));
    setIsLoaded(true);
  };

  React.useEffect(() => {
    findDesignLanding();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="col-12   justify-content-center">
      <div className="row justify-content-center  mb-3 mb-1">
        <div className="col-md-7 col-12">{parse(landing.text)}</div>
        <div className="col-md-5 col-12">
          <div className="row justify-content-center" dir="ltr">
            {isLoaded ? (
              <div className="col-12">
                <DesignCard design={landing.Design} auth={auth} />
              </div>
            ) : (
              <DesignCardSkeleton />
            )}
          </div>
        </div>
      </div>
      <div className="row justify-content-center ">
        <div className=" col-12 p-1">
          <video controls width="250">
            <source src={parse(landing.videoUrl)} type="video/mp4" />
          </video>
         
        </div>
      </div>
    </div>
  );
};

export default DesignLanding;
